import { useMemo } from 'react';

// Our Components
import DataTable from 'components/DataTable/DataTable';
import ColumnItem from 'components/DataTable/ColumnItem';

// Our utils
import { dollarFormatter, roundToDecimal } from 'shared/utils';

function PylonDetailedRates({ selectedRate }) {
	const rateKey = 'rate';
	const aprKey = 'apr';
	const priceKey = 'totalCost';
	const pointsKey = 'totalPoints';
	const loanAmountKey = 'principal';
	const downPaymentKey = 'downPaymentAmount';
	const pAndIKey = 'principalAndInterest';
	const taxesKey = 'taxes';
	const hoiKey = 'hoi';
	const monthlyPaymentKey = 'monthlyPayment';

	const columns = useMemo(() => {
		return [
			ColumnItem(rateKey, 'Rate', 0.5, {
				valueFormatter: ({ value }) => {
					return `${roundToDecimal(value, 2)}%`;
				}
			}),
			ColumnItem(aprKey, 'APR', 0.5, {
				valueFormatter: ({ value }) => {
					return `${roundToDecimal(value, 2)}%`;
				}
			}),
			ColumnItem(priceKey, 'Price', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			}),
			ColumnItem(pointsKey, 'Points', 1),
			ColumnItem(loanAmountKey, 'Loan Amount', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			}),
			ColumnItem(downPaymentKey, 'Down Payment', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			}),
			ColumnItem(pAndIKey, 'P&I', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			}),
			ColumnItem(taxesKey, 'Taxes Est', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			}),
			ColumnItem(hoiKey, 'HOI Est', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			}),
			ColumnItem(monthlyPaymentKey, 'Monthly Payment', 1, {
				valueFormatter: ({ value }) => {
					return dollarFormatter.format(value);
				}
			})
		];
	}, []);

	const cachedRows = useMemo(() => {
		return selectedRate.rates.map((rate) => {
			return {
				...rate,
				id: rate.rateId,
				taxes: rate.pitia.propertyTaxes,
				hoi: rate.pitia.hazardInsurance,
				principalAndInterest: rate.pitia.principalAndInterest
			};
		});
	}, [selectedRate]);

	return (
		<DataTable
			pageSize={15}
			disableSelectionOnClick
			disableCursor
			rows={cachedRows}
			columns={columns}
			getRowClassName={(params) => {
				if (params.row.rateId === selectedRate.rateId) {
					return 'MuiDataGrid-row-special';
				}
				return 'MuiDataGrid-row';
			}}
		/>
	);
}

export default PylonDetailedRates;
